import styled from 'styled-components';
import Grid from '../../atoms/Grid';
export const Container = styled(Grid)({
  gridTemplateColumns: 'auto 1fr',
  alignItems: 'center',
  padding: '6px 12px'
});
export const IconContainer = styled.div`
  margin-right: 7px;
`;
export const Button = styled.button`
  background-color: transparent;
  cursor: pointer;
  border: none;
  text-decoration: none;
`;
export const ItemContainer = styled.div``;